import type { Rank } from '../lib/types'
import { RankEmblem } from './RankEmblem'

export function RankBadge({
  rank,
  unrankedLabel = 'N/C',
}: {
  rank: Rank | null
  unrankedLabel?: string
}) {
  return (
    <span className={`rank-badge ${rank ? `rank-badge--${rank.id}` : ''}`}>
      {rank ? (
        <RankEmblem label={rank.displayName} rankId={rank.id} size="small" />
      ) : (
        <span aria-hidden="true" className="rank-badge__unranked">
          ◇
        </span>
      )}
      {rank?.displayName ?? unrankedLabel}
    </span>
  )
}
